import React from 'react';
import { DatePickerView } from './view';
import { styles } from './styles';

export class DatePicker extends React.Component {
  render() {
    return <DatePickerView {...this.props} styles={styles} />;
  }
}
